import { Phone, MapPin, ArrowUpRight, Star } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 lg:pt-36 pb-16 lg:pb-24 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        {/* Overline row */}
        <div className="flex items-center justify-between mb-10 lg:mb-14">
          <span className="overline">Mississauga · Est. 1984</span>
          <div className="hidden md:flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-ink-500">
            <Star className="w-3.5 h-3.5 fill-gold text-gold" />
            <Star className="w-3.5 h-3.5 fill-gold text-gold" />
            <Star className="w-3.5 h-3.5 fill-gold text-gold" />
            <Star className="w-3.5 h-3.5 fill-gold text-gold" />
            <Star className="w-3.5 h-3.5 fill-gold text-gold" />
            <span className="ml-2">Best Salon · 13 Years Running</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-end">
          {/* Headline */}
          <div className="lg:col-span-7">
            <img
              data-testid="hero-logo"
              src="/flavios-logo.png"
              alt="Flavio's"
              className="h-24 sm:h-28 lg:h-36 w-auto object-contain mb-8"
            />
            <h1
              data-testid="hero-headline"
              className="font-serif font-light text-ink-900 text-6xl sm:text-7xl lg:text-[8rem] leading-[0.92] tracking-tighter"
            >
              Where<br />
              <span className="italic text-gold">every strand</span><br />
              tells a story.
            </h1>
            <p className="mt-10 max-w-xl text-lg text-ink-500 leading-relaxed">
              For more than four decades, Flavio&apos;s House of Hair Design has
              shaped Mississauga&apos;s most memorable looks — cut by cut, colour
              by colour, compliment by compliment.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="tel:+19058222690"
                data-testid="hero-call-btn"
                className="btn-primary"
              >
                <Phone className="w-4 h-4" />
                Call (905) 822-2690
              </a>
              <a
                href="https://www.google.com/maps/search/?api=1&query=1900+Dundas+St+W+Mississauga+ON+L5K+1P9"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-directions-btn"
                className="btn-secondary"
              >
                <MapPin className="w-4 h-4" />
                Get Directions
              </a>
            </div>

            <div className="mt-10 flex items-center gap-6 text-xs tracking-[0.2em] uppercase text-ink-500">
              <span>Free Consultations</span>
              <span className="w-1 h-1 bg-ink-300 rounded-full" />
              <span>Walk-ins Welcome</span>
            </div>
          </div>

          {/* Image column */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[3/4] overflow-hidden bg-sand-200">
              <img
                src="/hero-hair.jpg"
                alt="Silky smooth hair by Flavio's"
                className="w-full h-full object-cover img-hover"
              />
            </div>

            {/* Floating award card */}
            <div
              data-testid="hero-award-badge"
              className="absolute -left-6 sm:-left-16 lg:-left-28 bottom-8 bg-sand-50 border border-black/10 p-6 lg:p-8 max-w-[260px] shadow-xl shadow-black/5"
            >
              <div className="overline mb-3">Award Winning</div>
              <p className="font-serif text-3xl lg:text-4xl text-ink-900 leading-tight">
                13 Years<br />of &ldquo;Best Salon&rdquo;
              </p>
              <div className="mt-4 flex items-center gap-2 text-xs tracking-[0.15em] uppercase text-ink-500">
                <ArrowUpRight className="w-3.5 h-3.5" />
                Mississauga&apos;s Choice
              </div>
            </div>
          </div>
        </div>

        {/* Bottom row - key stats */}
        <div className="mt-24 lg:mt-32 pt-10 border-t border-black/10 grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-4">
          {[
            { k: "40+", v: "Years Serving Mississauga" },
            { k: "13×", v: "Best Salon Award Winner" },
            { k: "5.0", v: "Average Stylist Rating" },
            { k: "∞", v: "Hair Dreams Delivered" },
          ].map((s) => (
            <div key={s.v} data-testid={`hero-stat-${s.k}`} className="flex flex-col">
              <span className="font-serif font-light text-5xl lg:text-6xl text-ink-900">
                {s.k}
              </span>
              <span className="mt-2 text-xs tracking-[0.2em] uppercase text-ink-500 max-w-[14ch]">
                {s.v}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
